module.exports = __webpack_public_path__ + "static/media/no.e41f9ad3.png";